import React, { Fragment, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import axioInstance from '../axiosInstance';
import { Decryption } from '../global';
import InvestmentInput from '../utils/InvestmentInput';

export default function Nps({ active, iValues, maxCount, nextActive, investment, activeAsset, current, setCurrent, StepChange, steps, nextStep, lifeStage, setPopupContent, setShow, setPopupTitle, setActiveStep }) {

  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [checkboxCheck, setCheckboxCheck] = useState(true);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [riskProfile, setRiskProfile] = useState();
  const [riskSource, setRiskSource] = useState();
  const [investmentData, setInvestmentData] = useState({
    self: {},
    spouse: {}
  });

  // eslint-disable-next-line
  const [checkboxCheckspouse, setCheckboxCheckspouse] = useState((lifeStage === "single" || lifeStage === "separatedWithKids") ? false : true);

  const getAdminId = () =>
    sessionStorage.getItem('admin_id') ||
    Decryption(sessionStorage.getItem('profile_id'));

  const getBasePayload = (statusType, remarks) => ({
    statusType,
    statusDate: new Date(),
    statusRemarks: remarks,
    plan_type: 10,
    profile_id: sessionStorage.getItem('profile_id'),
    monthly_amount: 0,
    yearly_amount: 0,
    increase_by: '',
    admin_id: getAdminId()
  });


  /*const AddFpPlanStatus = () => {

    var today = new Date();
    const statuType = riskProfile === 'Set' ? 2 : 3;

    const Postdata = {
      "statusType": statuType,
      "statusDate": today,
      "statusRemarks": 'Step Completed',
      "plan_type": 10,
      "profile_id": sessionStorage.getItem('profile_id'),
      "monthly_amount": 0,
      "yearly_amount": 0,
      "increase_by": '',
      "admin_id": sessionStorage.getItem('admin_id') ? sessionStorage.getItem('admin_id') : Decryption(sessionStorage.getItem('profile_id'))
    };

    // logical fields - start_date, months
    axioInstance.post(`fpplanstatus/add-update`, Postdata)
      .then(function (response) {

        axioInstance.post(`profile/update-zoho-crm-profile`, Postdata).then(function (response) {

          if (riskSource === '2' && riskProfile !== 'Set') {

            var todayplan = new Date();

            const statuType = 3;

            const Postdata = {
              "statusType": statuType,
              "statusDate": todayplan,
              "statusRemarks": 'Plan Completed',
              "plan_type": 10,
              "profile_id": sessionStorage.getItem('profile_id'),
              "monthly_amount": 0,
              "yearly_amount": 0,
              "increase_by": '',
              "admin_id": sessionStorage.getItem('admin_id') ? sessionStorage.getItem('admin_id') : Decryption(sessionStorage.getItem('profile_id'))
            };

            // logical fields - start_date, months
            axioInstance.post(`fpplanstatus/add-update`, Postdata)
              .then(function (response) {

                axioInstance.post(`profile/update-zoho-crm-profile`, Postdata)
                  .then(function (response) {
                    window.location.reload();
                  });

              });
          }
        });

      });

  }*/

  const AddFpPlanStatus = async () => {
    try {
      const initialStatusType = riskProfile === 'Set' ? 2 : 3;

      const initialPayload = getBasePayload(
        initialStatusType,
        'Step Completed'
      );

      await axioInstance.post('fpplanstatus/add-update', initialPayload);
      await axioInstance.post('profile/update-zoho-crm-profile', initialPayload);

      console.log('riskSource:', riskSource);
      console.log('riskProfile:', riskProfile);

      // Conditional final step
      if (riskSource === '2' && riskProfile !== 'Set') {
        const finalPayload = getBasePayload(3, 'Plan Completed');
        console.log('Initial fpplanstatus/update successful');
        await axioInstance.post('fpplanstatus/add-update', finalPayload);
        await axioInstance.post('profile/update-zoho-crm-profile', finalPayload);
      }

      //window.location.reload();
    } catch (error) {
      console.error('AddFpPlanStatus failed:', error);
    }
  };


  const getSelfData = async () => {
    try {
      const profile_id = sessionStorage.getItem('profile_id');
      const { data } = await axioInstance.post('profile/selfdata', { profile_id });
      setActiveStep(data.self_data.stepper);
    } catch (error) {
      console.error('getSelfData failed:', error);
    }
  };

  /*const getSelfData = () => {

    const profile_id = sessionStorage.getItem('profile_id');
    axioInstance.post(`profile/selfdata`, { profile_id }).then(function (response) {
      setActiveStep(response.data.self_data.stepper);
    })
  }*/

  /*const nextStepCall = () => {
    if (current + 1 === maxCount) {
      axioInstance.post(`profile/update-stepper`, { profile_id: sessionStorage.getItem('profile_id'), step: steps + 1 }).then(function (response, data) {
        AddFpPlanStatus();
        StepChange(nextStep(steps));
        getSelfData()
      });
    } else {
      setCurrent(current + 1);
      activeAsset(iValues[current + 1].id);
    }
    setButtonSpinner(false);
  }*/

  const nextStepCall = async () => {
    try {
      if (current + 1 === maxCount) {
        await axioInstance.post('profile/update-stepper', {
          profile_id: sessionStorage.getItem('profile_id'),
          step: steps + 1
        });

        await AddFpPlanStatus();
        StepChange(nextStep(steps));
        await getSelfData();
      } else {
        const nextIndex = current + 1;
        setCurrent(nextIndex);
        activeAsset(iValues[nextIndex].id);
      }
    } catch (error) {
      console.error('nextStepCall failed:', error);
    } finally {
      setButtonSpinner(false);
    }
  };


  const profileId = sessionStorage.getItem("profile_id");
  const profileDetailsId = sessionStorage.getItem("profile_details_id");
  const adminId = sessionStorage.getItem("admin_id");
  // eslint-disable-next-line
  const spouseDetailsId = sessionStorage.getItem("spouse_prof_det_id");

  const handleInvestmentPost = async (data) => {

    console.log('postData', data);

    try {
      await axioInstance.post("investment/add-investment", data);
      return true;
    } catch (error) {
      setShow(true);
      setPopupTitle("NPS");
      setPopupContent("Error adding investment. Please try again.");
      return false;
    }
  };

  const onSubmit = async (mfdata) => {

    setButtonSpinner(true);

    // logic for no and skip to next
    if (!checkboxCheck || (mfdata.selfCurrentVal === "0" && mfdata.selfInvested === "0" && mfdata.selfInvestId === '')) {
      nextStepCall();
      return;
    }

    const postData = (relation, detailsId, CurrentVal, currentValueDigits, InvestedDigits, invested, frequency, investId) => ({
      prop_id: profileId,
      profile_id: profileId,
      profile_details_id: detailsId,
      type: 11,
      owner: profileId,
      invest_type: 0,
      sub_type: 1,
      instr_name: `${relation} NPS Portfolio`,
      spec_type: 1,
      frequency: frequency,
      current_value: CurrentVal * currentValueDigits,
      cost_amount: CurrentVal * currentValueDigits,
      value_total: CurrentVal * currentValueDigits,
      amount: invested * InvestedDigits,
      invest_amount: invested * InvestedDigits,
      tenure: 1,
      invest_id: investId,
      moneyDigits: currentValueDigits,
      admin_id: adminId
    });

    if (mfdata.selfCurrentVal !== 0) {
      const selfInvestment = postData("self", profileDetailsId, mfdata.selfCurrentVal, mfdata.selfValueMoneyType, mfdata.selfInvestedMoneyType, mfdata.selfInvested, mfdata.selfFrequency, mfdata.selfInvestId);

      if (await handleInvestmentPost(selfInvestment)) {

        if (checkboxCheckspouse && mfdata.spouseCurrentVal !== 0) {
          const spouseInvestment = postData("spouse", spouseDetailsId, mfdata.spouseCurrentVal, mfdata.spouseValueMoneyType, mfdata.spouseInvestedMoneyType, mfdata.spouseInvested, mfdata.spouseFrequency, mfdata.spouseInvestId);
          if (await handleInvestmentPost(spouseInvestment)) {
            nextStepCall();
          }
        } else {
          nextStepCall();
        }

      }
    } else {
      nextStepCall();
    }

  }

  const validateCheckbox = (checkbox, type) => {
    const isChecked = checkbox !== "no";

    if (type === "self") {
      setCheckboxCheck(isChecked);
    }
  };

  /*useEffect(() => {

    const fetchInvestmentData = async () => {
      try {
        const profile_id = sessionStorage.getItem('profile_id');

        const response = await axioInstance.post(`profile/get-investments`, {
          profile_id,
          type: 11,
          sub_type: 1
        });

        const profileSummary = await axioInstance.post(`profile/summary`, { profile_id });

        console.log('profileSummary', profileSummary?.risk_profile?.add_source);

        setRiskProfile(profileSummary?.risk_profile?.description ? profileSummary?.risk_profile?.description : 'Set');
        setRiskSource(profileSummary?.risk_profile?.add_source ? profileSummary?.risk_profile?.add_source : '1');

        const selfData = response.data.find(item => item.relation === "self") || {};
        const spouseData = response.data.find(item => item.relation === "spouse") || {};

        setInvestmentData({
          self: selfData,
          spouse: spouseData
        });

      } catch (error) {
        console.error("Error fetching investment data:", error);
      }
    };

    fetchInvestmentData();

  }, []);*/

  useEffect(() => {

    const fetchInvestmentData = async () => {
      try {
        const profile_id = sessionStorage.getItem('profile_id');

        // Parallel API calls (performance improvement)
        const [
          investmentRes,
          profileSummaryRes
        ] = await Promise.all([
          axioInstance.post('profile/get-investments', {
            profile_id,
            type: 11,
            sub_type: 1
          }),
          axioInstance.post('profile/summary', { profile_id })
        ]);

        const profileSummary = profileSummaryRes.data;

        console.log(
          'risk source:',
          profileSummary?.risk_profile?.add_source
        );

        setRiskProfile(
          profileSummary?.risk_profile?.description || 'Set'
        );

        setRiskSource(
          profileSummary?.risk_profile?.add_source || '1'
        );

        const selfData =
          investmentRes.data.find(item => item.relation === 'self') || {};

        const spouseData =
          investmentRes.data.find(item => item.relation === 'spouse') || {};

        setInvestmentData({
          self: selfData,
          spouse: spouseData
        });

      } catch (error) {
        console.error('Error fetching investment data:', error);
      }
    };

    fetchInvestmentData();

  }, []);


  return (
    <Fragment>

      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="formtitle flex_center justify_center">
          <div>
            <div className="font20 fw600">Investment</div>
            <div className="font15 color495 ">Also a bit approximate idea about your commitments</div>
          </div>
          <div>


            <button className="bluebtn font13 fw600 d-none d-md-block" type={buttonSpinner ? "button" : "submit"}>{buttonSpinner ? <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> loading</> : "Save"}
              <span className="whitearrow"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9C2.25217 7.6 3.26957 6.54783 4.87826 5.29565C5.06957 5.14783 5.06957 4.85217 4.87826 4.70435C3.26957 3.45217 2.25217 2.4 1 1" stroke="white" strokeWidth="1.30435" strokeMiterlimit="10" />
              </svg></span></button>
          </div>
        </div>

        <div className="pt35">

          <div className="investmentTabs mb20">

            <ul>

              {investment.map((data, i) => {

                return (data.checked === true && (<Fragment>

                  <li className={data.id}>
                    <label>
                      <input type="radio" name="assets" />
                      <div class={active === data.id ? 'investmentTabs_text act' : 'investmentTabs_text'}>{data.name}</div>
                    </label>
                  </li>
                </Fragment>)
                );
              })}
            </ul>
          </div>

        </div>

        <div className="custome_form" >




          <div className="pl35 pr35">

            <div className="form-row mb-2">
              <div>
                <div className="color212 font14 fw600">Do you want to add NPS? <span className="colorfa8">*</span>
                </div>
                <ul className="steps_tag font14 fw500 color182 mt15">
                  <li>
                    <label>
                      <input type="radio" name="investmentCheck" {...register("investmentCheck", { required: 'Required' })} value="yes" onClick={() => validateCheckbox('yes', 'self')} checked={checkboxCheck === true ? "checked" : ""} />
                      <span className="rdo_text_box">
                        Yes
                      </span>
                    </label>
                  </li>
                  <li>
                    <label>
                      <input type="radio" name="investmentCheck" {...register("investmentCheck", { required: 'Required' })} value="no" onClick={() => validateCheckbox('no', 'self')} checked={checkboxCheck === false ? "checked" : ""} />
                      <span className="rdo_text_box">
                        No
                      </span>
                    </label>
                  </li>
                </ul>
                <span className="text-danger"> {errors.investmentCheck && errors.investmentCheck.message}</span>
              </div>
            </div>


            {
              checkboxCheck === true &&
              (
                <>
                  <InvestmentInput
                    register={register}
                    errors={errors}
                    namePrefix="self"
                    currentValueLabel="Current Value of your nps"
                    periodicInvestmentLabel="Periodic investment"
                    maxZero={3}
                    investmentData={investmentData.self} // Pass data for self
                    setValue={setValue}
                  />
                </>
              )
            }


            <div className="form-row mt25 pb35">


              {

                (checkboxCheckspouse === true && checkboxCheck === true) &&

                (
                  <>
                    <div className="formdevider mt15 mb15" />
                    <InvestmentInput
                      register={register}
                      errors={errors}
                      namePrefix="spouse"
                      currentValueLabel="Current Value of your nps"
                      periodicInvestmentLabel="Periodic investment"
                      maxZero={3}
                      investmentData={investmentData.spouse} // Pass data for self
                      setValue={setValue}
                    />
                  </>
                )
              }
            </div>
          </div>
        </div>

        <div className="saveBtn d-block d-sm-none">
          <button type={buttonSpinner ? "button" : "submit"} className="btn btn-primary">{buttonSpinner ? <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> loading</> : "Save"} <span className="whitearrow"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9C2.25217 7.6 3.26957 6.54783 4.87826 5.29565C5.06957 5.14783 5.06957 4.85217 4.87826 4.70435C3.26957 3.45217 2.25217 2.4 1 1" stroke="white" strokeWidth="1.30435" strokeMiterlimit="10"></path></svg></span></button>
        </div>
      </form>
    </Fragment>
  )
}
